export interface  TreeViewItem {
  id: string
  icon: string
  name?: string
  archived?: boolean
  original?: any
  imageUrl?: string
  parent: TreeViewItem
  isParent?: boolean
  type: TreeViewItemTypeEnum
  hasMaintenanceInProgress?: boolean
  hasOnlyMaintenanceInProgress?: boolean
  children?: TreeViewItem[]
}

export enum TreeViewItemTypeEnum {
  Equipment = 'equipment',
  Location = 'location',
  LocationEnvironment = 'locationEnvironment',
  LocationSector = 'locationSector'
}

export interface SelectNodeSubject {
  id: string
  showDetails?: boolean
}
